import { useContext } from 'react';
import UserContext from './context/UserContext';

const useUserData = () => {
  return useContext(UserContext);
};

export default useUserData;
